export default __webpack_public_path__ + "6a6d90f93975724772c62ed4117f83d4.js";